import { atom, selector } from 'recoil'

import { MESSAGE_LIST_TYPE_NOT_ARCHIVED } from 'Constants'
import { DEFAULT_PAGE_SIZE } from '../../constants'

export const searchState = atom({
  key: 'messageListSearchState',
  default: {
    searchText: '',
    searchInContent: undefined,
    tags: [],
    type: MESSAGE_LIST_TYPE_NOT_ARCHIVED,
    filterByField: 'LastUpdated',
    filterByFieldFrom: undefined,
    filterByFieldTo: undefined,
    orderBy: 'LastUpdated DESC',
    pageNumber: 1,
    pageSize: DEFAULT_PAGE_SIZE
  }
})

export const orderByState = selector({
  key: 'messageListSearchStateOrderBy',
  get: ({ get }) => get(searchState).orderBy,
  set: ({ set, get }, value) => {
    const prev = get(searchState)
    set(searchState, {
      ...prev,
      orderBy: value
    })
  }
})

/* export const tagsState = selector({
  key: 'messageListTagsState',
  get: ({ get }) => {
    const idList = parseInt(storeGet(STORE_KEY_ID_LIST))
    return BeListApiGetAllTags(idList, true, false).then(res => {
      return res.Items.map(t => ({
        label: t.Name,
        value: t.Id
      }))
    })
  }
}) */

export const tagsState = atom({
  key: 'messageListTagsState',
  default: [{ label: '', value: 0 }]
})
